<template>
    <div class="publishhouse" style="width:800px">
        <form class="form_item">
            <el-row class="step_item">
                <label>请上传您的房源照片:</label>
                <el-row class="upload_img">
                    <el-upload class="upload_demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"><el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-row>
            </el-row>
            <el-row class="step_item">
                <label>您希望的月租金价格:</label>
                <el-row class="rent_demo">￥&nbsp;<el-input class="max_input" v-model="thirdObj.MAX_ZJ" placeholder="请输入租金"></el-input>&nbsp;/月</el-row>
                <el-row class="rent_demo"><span><strong>建议:</strong>根据您的房源信息我们建议您以￥15000每月出租</span></el-row>
                <el-row class="rent_demo">
                    <label>价格详情:</label>
                    <el-row class="radio_select">
                        <label>发票</label>
                        <el-radio v-model="radio1" label="1">包</el-radio>
                        <el-radio v-model="radio1" label="2">不包</el-radio>
                        <label>物业费</label>
                        <el-radio v-model="radio2" label="1">包</el-radio>
                        <el-radio v-model="radio2" label="2">不包</el-radio>
                        <label>水电煤</label>
                        <el-radio v-model="radio3" label="1">包</el-radio>
                        <el-radio v-model="radio3" label="2">不包</el-radio>
                    </el-row>
                    <el-row class="radio_select">
                        <label>宽度</label>
                        <el-radio v-model="radio4" label="1">包</el-radio>
                        <el-radio v-model="radio4" label="2">不包</el-radio>
                        <label>卫星电视</label>
                        <el-radio v-model="radio5" label="1">包</el-radio>
                        <el-radio v-model="radio5" label="2">不包</el-radio>
                        <label>会所</label>
                        <el-radio v-model="radio6" label="1">包</el-radio>
                        <el-radio v-model="radio6" label="2">不包</el-radio>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="step_item">
                <label>您的联系方式:</label>
                <el-row class="self_demo"><span>姓名:&nbsp;</span><el-input class="max_input" v-model="thirdObj.NickName" placeholder="请输入姓名"></el-input></el-row>
                <el-row class="self_demo"><span>邮箱:&nbsp;</span><el-input class="max_input" v-model="thirdObj.NegEmail" placeholder="请输入邮箱"></el-input></el-row>
                <el-row class="self_demo"><span>电话:&nbsp;</span><el-input class="max_input" v-model="thirdObj.NegPhone1" placeholder="请输入电话"></el-input></el-row>
                
            </el-row>
        </form>
    </div>
</template>

<script>
export default {
    props:[
        "houseMessage"
    ],
    data(){
        return {
            thirdObj: {
                MAX_ZJ: '',
                NegEmail: '',
                NegPhone1: '',
                NickName: ''
            },
            priceOption: [],
            dialogImageUrl: '',
            dialogVisible: false,
            rent: '',
            myNama: '',
            myEmail: '',
            myPhone: '',
            radio1: 1,
            radio2: 1,
            radio3: 1,
            radio4: 1,
            radio5: 1,
            radio6: 1

        }
    },
    methods:{

      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleRemove(file, fileList) {
        
      },
      gethousePrice(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'price_details'},data => {
                this.priceOption = data
                // console.log(data)
            },err => {
 
            })
        },
    },
    created(){
        this.gethousePrice()
    }
}
</script>

<style scoped>
.publishhouse .max_input{
    display: inline-block
}
</style>



// WEBPACK FOOTER //
// src/pages/publishHouse/components/publishThird.vue